// @flow
import React, {PureComponent} from 'react';
import ReactDOM from 'react-dom';

import type {Node} from 'react';

type Props = {
    children?: Node,
    pixelOffset: Object, // google maps size object
    infoBoxClearance?: Object, // also google maps size object
    boxClass?: string,
    marker?: Object, // google maps marker object
    map?: Object, // google maps map object
    disableAutoPan?: boolean
};

export default class Overlay extends PureComponent<Props> {
    infobox: Object;

    constructor(props: Props) {
        super();

        const {
            pixelOffset,
            map,
            infoBoxClearance,
            boxClass,
            disableAutoPan
        } = props;
        const {InfoBox} = require('google-maps-infobox');
        const infobox = new InfoBox({
            boxClass: boxClass || 'infoBox',
            disableAutoPan,
            closeBoxURL: '', // hide the X (close) button
            pixelOffset,
            infoBoxClearance,
            alignBottom: true,
            boxStyle: {
                overflow: 'visible'
            }
        });
        infobox.setMap(map);
        this.infobox = infobox;
    }

    componentDidMount() {
        const content = document.createElement('div');
        ReactDOM.unstable_renderSubtreeIntoContainer(
            this,
            React.Children.only(this.props.children),
            content
        );
        this.infobox.setContent(content);
        this.infobox.open(this.props.map, this.props.marker);
    }

    componentDidUpdate() {
        this.infobox.setOptions({boxClass: this.props.boxClass});
    }

    componentWillUnmount() {
        if (this.infobox && this.infobox.getContent()) {
            ReactDOM.unmountComponentAtNode(this.infobox.getContent());
            this.infobox.setMap(null);
        }
    }

    render() {
        return null;
    }
}
